import React, { useRef, useEffect } from "react";
import "../css/cyberinsurance.css";
import cyberinsuranceimg from "../assets/cyberinsuranceimg.webp";
import tollfreenumberimg from "../assets/tollfreenumberimg.webp";
import PoliciesSlider from "../components/PolicyiesSlider";
import ConsultationForm from "../components/ConsultationForm";
import ChatbotAi from "../components/ChatbotAi";
import axios from "axios";
import { Helmet } from 'react-helmet-async';

const CyberInsurance = () => {
    const API_URL = process.env.REACT_APP_Dashboard_API_URL;
    const imageRefs = useRef([]);
    const imageSources = [
        cyberinsuranceimg,
        tollfreenumberimg
    ];

    useEffect(() => {
        if (imageRefs.current.length > 0) {
            let index = 0;

            const showNextImage = () => {
                imageRefs.current.forEach((img, i) => {
                    if (img) img.style.display = i === index ? "block" : "none";
                });

                index++;
                if (index >= imageRefs.current.length) index = 0;
                setTimeout(showNextImage, 3000);
            };

            showNextImage();
        }
    }, []);

    const handleSubmit = async (data) => {
        const inquriyData = new FormData();
        inquriyData.append("Name", data.Name);
        inquriyData.append("Email", data.Email);
        inquriyData.append("PreferredDate", data.Date);
        inquriyData.append("PreferredTime", data.Time);
        inquriyData.append("MobileNo", data.MobileNo);
        inquriyData.append("Status", "New");
        inquriyData.append("UserId", data.Id);
        inquriyData.append("InquiryType", "Insurance Inquiries");
        inquriyData.append("PolicyType", "Cyber Insurance");
        inquriyData.append("IsLoggedIn", data.isLoggedIn);
        inquriyData.append("Otp", data.OTP);

        try {
            const response = await axios.post(`${API_URL}AddNewInquiries`, inquriyData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return { status: response.status, data: response.data };
        } catch (error) {
            console.error("Error submitting consultation request:", error);
            return {
                status: 500,
                data: {
                    success: false,
                    message: error.response?.data?.message
                }
            };
        }
    };

    return (
        <div className="cyberinsurance-container">
            <Helmet>
                <title>Cyber Insurance Explained | Secure Your Digital Business</title>
                <meta
                    name="description"
                    content="Discover why cyber insurance matters for your business. Clear guidance on policies that protect you from online risks and data threats."
                />
                <meta
                    name="keywords"
                    content="cyber insurance consultation, digital asset protection, data breach insurance India, cyber security insurance advice, protect against online fraud"
                />
                <link rel="canonical" href="https://policysamjho.com/cyber-insurance-explained/" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "Cyber Insurance Explained",
                        "description": "Understand cyber insurance policies in simple terms. Protect yourself and your business from digital risks with Policy Samjho guidance.",
                        "provider": {
                            "@type": "Organization",
                            "name": "Policy Samjho",
                            "url": "https://policysamjho.com/"
                        },
                        "serviceType": "Cyber Insurance Consultation",
                        "areaServed": "IN",
                        "url": "https://policysamjho.com/cyber-insurance-explained/",
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "+91-9584484800",
                            "email": "info@policysamjho.com",
                            "contactType": "customer service"
                        }
                    })}
                </script>
            </Helmet>
            <div className="cyberinsurance-hero-container">
                <div className="cyberinsurance-hero-text-box">
                    <h1>
                        <span style={{ color: '#192437' }}>Cyber Insurance </span>
                        <span style={{ color: '#F5A526' }}>Explained</span>
                    </h1>

                    <p style={{ color: "black", fontWeight: "600", fontSize: "18px", textAlign: 'justify' }}>
                        Discover why cyber insurance matters for your business. Get clear guidance
                        on policies that protect you from online risks and data threats.
                    </p>
                </div>
                <div className="cyberinsurance-hero-image-box cyberinsurance-imgslider">
                    {imageSources.map((image, index) => (
                        <img
                            key={index}
                            ref={(el) => (imageRefs.current[index] = el)}
                            src={image}
                            className="cyberinsurance-sliderimg"
                            alt={`cyberinsurance-slide-${index}`}
                            style={{ display: index === 0 ? "block" : "none" }}
                        />
                    ))}
                </div>
            </div>

            <div className="cyberinsurance-containform-container">
                <div className="col-md-6 cyberinsurance-info">
                    <h2 className="cyberinsurance-heading">
                        <span style={{ color: '#192437' }}>What is </span>
                        <span style={{ color: '#F5A526' }}>Cyber Insurance?</span>
                    </h2>
                    <p className="cyberinsurance-text">
                        Cyber insurance provides financial protection against cyber threats, including hacking, phishing, malware, and data breaches, ensuring your digital security.
                    </p>

                    <h2 className="cyberinsurance-subheading">
                        <span style={{ color: '#192437' }}>Comprehensive Coverage & </span>
                        <span style={{ color: '#F5A526' }}>Insurance Benefits</span>
                    </h2>
                    <ul className="cyberinsurance-benefits">
                        <li>Legal expense coverage</li>
                        <li>Coverage for data breaches</li>
                        <li>Protection from cyber-attacks</li>
                        <li>Financial assistance for fraud recovery</li>
                    </ul>

                    <p className="cyberinsurance-text spaced-text">
                        Cyber insurance protects businesses and individuals from financial losses due to cyber threats. Coverage includes data restoration, identity theft protection, and response to cyber incidents. Policies also offer legal and regulatory compliance support, helping mitigate financial risks associated with cyber-attacks.
                    </p>
                </div>

                <div>
                    <h4 className="consultationform-heading">
                        <span style={{ color: "#192437" }}>Get a Free </span>
                        <span style={{ color: "#F5A526" }}> Cyber Insurance Quote </span>
                    </h4>
                    <ConsultationForm onSubmit={handleSubmit} />
                </div>
            </div>

            <PoliciesSlider category="Cyber Insurance" />
            <ChatbotAi />
        </div>
    );
};

export default CyberInsurance;
